export const collator = new Intl.Collator(undefined, {
  sensitivity: 'base',
});
